export function jsScroll() {

    //js-scroll
    var wH = $(window).height();
    var EffectH = wH/5*1;
    jQuery(window).on('scroll load', function() {
        var scTop = $(this).scrollTop();
        var scBottom = scTop + $(this).height();
        var effectPos = scBottom - EffectH;
        jQuery('.js-scroll, .js-scroll-delay').each( function() {
        var thisPos = $(this).offset().top;
        if ( thisPos < effectPos ) {
            $.when(
            jQuery(this).addClass("show")
            ).done(function() {
            jQuery(this).delay(250).queue(function(){
                jQuery(this).addClass("done")
            })
            });
        }
        });
    });
    
}
